import { DataTable, FieldSet, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";

import { ExportGapRemplacementApi, RechercheExportGapSearch } from "../../../../api";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";

export interface IExportationGapRemplacementsListPageProps {
  idExport: number;
}

export const ExportationGapRemplacementsListPage: React.FunctionComponent<IExportationGapRemplacementsListPageProps> = ({
  idExport
}) => {
  const { t } = useTl();
  const api = useApiService(ExportGapRemplacementApi);

  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: true,
    enableFilter: false,
    availablePageSizes: [15, 25, 50],
    pageSize: 15,
    sortKeys: { jour: "DESC" }
  });

  const { totalCount } = tableState;

  const searchFunction = React.useCallback(
    (sObj?: RechercheExportGapSearch) => {
      sObj.idexport = idExport;
      return api.exportGapRemplacementBaseSearch({ RechercheExportGapSearch: sObj });
    },
    [api, idExport]
  );
  const { loading } = useSearchApi<any, any>({
    searchFunction,
    tableState,
    initialSearch: true
  });

  const columns = React.useMemo(
    () => [
      {
        header: () => t(ETLCodes.Jour),
        fieldName: "jour"
      },
      {
        header: () => t(ETLCodes.Formateur),
        fieldName: "matricule"
      },
      {
        header: () => t(ETLCodes.Classe),
        fieldName: "codeClasse"
      },
      {
        header: () => t(ETLCodes.HeuresPrestees),
        fieldName: "count"
      },
      {
        header: () => t(ETLCodes.Signe),
        fieldName: "signe"
      }
    ],
    [t]
  );

  return (
    <>
      {idExport > 0 && (
        <FieldSet title={t(ETLCodes.TableResults, { count: totalCount })}>
          <DataTable dateFormat="dd-MM-yyyy" tableState={tableState} loading={loading} columns={columns} />
        </FieldSet>
      )}
    </>
  );
};
